import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63f86b71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { style: {"margin":"0px 10px 0px 10px","line-height":"25px"} }
const _hoisted_4 = { class: "meiyihan" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "neirong" }, " 发布求助需要先提前支付所需酬劳积分，支付后才能完成发布。如按照求助时间前无人接单或求助审核不通过，酬劳会按照实际支付金额退回支付账户。 ", -1))
const _hoisted_6 = { class: "meiyihan" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "neirong" }, " 求助人在有求助单未完成时，不能发布新的求助单。 ", -1))
const _hoisted_8 = { class: "meiyihan" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "neirong" }, " 接单人点击完成订单，发单人没有任何反馈操作，超过3天该求助单会自动完成。 ", -1))
const _hoisted_10 = { class: "bottom-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_cell_group = _resolveComponent("van-swipe-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    teleport: "body",
    show: _ctx.show,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.show) = $event)),
    round: "",
    "close-on-click-overlay": false,
    style: { height: '350px', width: '90%' },
    class: "d-flex-column d-overflow-not main"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_icon, {
        name: "clear",
        size: "24",
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tongyi())),
        color: "#8A8B97"
      }),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.headTitle), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_swipe_cell_group, { inset: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_van_icon, {
                  name: "checked",
                  color: "#fd5c02"
                }),
                _hoisted_5
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_van_icon, {
                  name: "checked",
                  color: "#fd5c02"
                }),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_icon, {
                  name: "checked",
                  color: "#fd5c02"
                }),
                _hoisted_9
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_van_button, {
          "icon-position": "right",
          type: "primary",
          class: "btn2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tongyi()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("已读并同意")
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}